// extracted by mini-css-extract-plugin
export default {"container":"lang-switch_container__glPZF","desktopSwitch":"lang-switch_desktopSwitch__cgnRo","mobileSwitch":"lang-switch_mobileSwitch__zJTde"};